import { z } from 'zod';
// Base validation and DTO type
export const meetingEventStaffMemberBaseSchema = z.object({
    userId: z
        .number('A user is required')
        .describe('The government user serving as staff on this meeting.'),
    title: z
        .string('Title is required')
        .min(1, 'Title is required')
        .max(300, 'Title must be less than 300 characters')
        .describe('The role this user serves in for this meeting, e.g. "City Clerk".'),
});
/**
 * Replaces a meeting body's staff roster for one meeting. The whole roster is submitted at once
 * rather than patched member by member: until a meeting is customized its staff are the body's own
 * rows, which have no per-meeting ids to address, so the first edit has to write the complete list.
 *
 * An empty array is meaningful and distinct from resetting — it records that this meeting runs with
 * no staff for the body, and stays that way as the body's roster changes.
 */
export const meetingEventStaffRosterUpdateSchema = z.object({
    staffMembers: z
        .array(meetingEventStaffMemberBaseSchema, 'Staff members are required')
        .max(100, 'A meeting body cannot have more than 100 staff members')
        .describe('The complete staff roster for this meeting body on this meeting, where position in the array determines display order. Replaces the roster the meeting currently uses.'),
});
